module.exports = __webpack_public_path__ + "img/section-03@3x.77d2a969.png";